module.exports = __webpack_public_path__ + "static/media/event5.7c0cf319.jpg";